import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["poster", "src", "atl"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("video", {
    ref: "videoElement",
    poster: _ctx.posterUrl,
    src: _ctx.videoUrl,
    atl: _ctx.alt,
    autoplay: "",
    loop: "",
    muted: ""
  }, null, 8 /* PROPS */, _hoisted_1))
}